<template>
  <div>
    <div class="text-left mb-5">
      <span class="headline" id="headerlist">Job Order List</span>
    </div>
    <!-- Table Start -->
    <div class="holder">
      <div class="filter"></div>
      <div class="paginate">
        <v-select
          v-model="paginationcount"
          v-on:change="paginateList"
          :items="paginationcounts"
          item-text="name"
          item-value="name"
          :selected="paginationcounts.value === 10"
          label="show by"
        ></v-select>
      </div>
    </div>
    <v-simple-table fixed-header fixed-footer height="450px" class="elevation-2">
      <template v-slot:default>
        <thead>
          <tr class="tableheader">
            <th class="text-left">Item Category</th>
            <th class="text-left">Customer Name</th>
            <th class="text-left">Size/s</th>
            <th class="text-left">Weight of Gold</th>
            <th class="text-left">Karat of Gold</th>
            <th class="text-left">Color of Gold</th>
            <th class="text-left">No. and Size of Diamond</th>
            <th class="text-left">Price</th>
            <th class="text-left">Amount Down Payment</th>
            <th class="text-left">Amount Receivable/Balance</th>
            <th class="text-left">Date Ordered</th>
            <th class="text-left">Date Picked Up/Purchased</th>
            <th class="text-left">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in jobOrders" :key="item.id" @click="showJobOrder(item.id)">
            <td class="text-left">{{ item.category }}</td>
            <td class="text-left">{{ item.customer.name }}</td>
            <td class="text-left">{{ item.size }}</td>
            <td class="text-left">{{ item.weight }}</td>
            <td class="text-left">{{ item.karat }}</td>
            <td class="text-left">{{ item.color }}</td>
            <td class="text-left">{{ item.no_of_diamond }}</td>
            <td class="text-left">{{ parseFloat(item.price).toLocaleString() }}</td>
            <td class="text-left">{{ parseFloat(item.deposit).toLocaleString() }}</td>
            <td class="text-left">{{ parseFloat(item.balance).toLocaleString() }}</td>
            <td class="text-left">{{ item.date_ordered }}</td>
            <td :class="dateColor(item.date_pickup, item.status == 'completed')">
              {{ item.date_pickup }}
            </td>
            <td class="text-left">{{ item.status }}</td>
          </tr>
          <tr v-if="pagination.meta.total == 0">
            <td colspan="14" style="height:400px; text-align: center;">
              No records found
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div class="pt-2">
      <v-pagination
        v-if="pagination.meta.total > 0"
        align="right"
        v-model="page"
        :length="pagination.meta.last_page"
        circle
      ></v-pagination>
    </div>
    <!-- Table End -->
    <!-- Create Start -->
    <v-btn
      fixed
      bottom
      right
      @click="$router.push('/joborder/create')"
      color="blue darken-2"
      dark
      fab
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <jobOrderCreate
      v-if="create"
      :page="page"
      :create="create"
      @createChange="
        value => {
          this.create = value;
        }
      "
    />
    <jobOrderEdit v-if="edit" :page="page" :edit="edit" />
    <jobOrderShow v-if="show" :show="show" :page="page" :rawmaterial="rawmaterial" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import jobOrderCreate from './JobOrderCreate';
import jobOrderEdit from './JobOrderEdit';
import jobOrderShow from './JobOrderShow';

export default {
  data: function() {
    return {
      page: 1,
      paginationcount: '10'
    };
  },
  components: {
    jobOrderCreate,
    jobOrderEdit,
    jobOrderShow
  },
  props: {
    create: false,
    show: false,
    edit: false,
    rawmaterial: true
  },
  watch: {
    page(val) {
      this['JobOrder/fetchJobOrders']({ page: val, paginationcount: this.paginationcount });
    },
    $route(to, from) {
      if (this.show) {
        this['JobOrder/getJobOrder']({ id: to.params.id });
      }
    }
  },
  computed: {
    ...mapState({
      jobOrders: state => state.JobOrder.jobOrders.data,
      paginationcounts: state => state.Unit.paginationcount,
      pagination: state => {
        if (state.JobOrder.jobOrders.length === 0) {
          return {
            meta: {
              last_page: 0
            }
          };
        }
        return state.JobOrder.jobOrders;
      }
    })
  },
  mounted() {
    this['JobOrder/fetchJobOrders']({ page: this.page, paginationcount: this.paginationcount });
  },
  methods: {
    ...mapActions(['JobOrder/fetchJobOrders', 'JobOrder/getJobOrder']),
    showJobOrder(id) {
      this.$router.push(`/joborder/${id}`);
    },
    dateColor(date, completed) {
      const date_pickup = new Date(date);
      const current_date = new Date();
      if (date_pickup < current_date && !completed) {
        return 'text-left red--text';
      }

      return 'text-left';
    },
    paginateList() {
      if (this.page !== 1) this.page = 1;
      else this['JobOrder/fetchJobOrders']({ page: 1, paginationcount: this.paginationcount });
    }
  }
};
</script>
